// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hiddenDescribeContainer-rOb38 {\n  height: 0;\n  margin: 0;\n  overflow: hidden;\n  padding: 0;\n  width: 0;\n}\n.button-4eNaw {\n  display: flex;\n  align-items: center;\n  color: #554854;\n}\n.buttonTitle-OA1h9 {\n  margin-right: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.menu-Nf-LG {\n  color: #554854;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  font-size: 14px;\n  margin: 2px 0 0;\n  padding: 5px 10px;\n  position: absolute;\n  text-align: left;\n  min-width: 160px;\n  width: 195px;\n  line-height: 2.2rem;\n  z-index: 100;\n  overflow: hidden;\n}\n.menu-Nf-LG.hasSubMenu-XMMdY {\n  overflow: visible !important;\n}\n.menuList-mr6F2.hasSubMenu-XMMdY {\n  overflow: visible !important;\n  max-height: fit-content;\n}\n.menuTopAligned-4Y0nI {\n  margin-top: 0;\n}\n.menu-Nf-LG.hiddenMenu-DcSYT {\n  visibility: hidden;\n}\n.chevron-YygZ6 {\n  font-size: 14px !important;\n  height: 19px !important;\n  width: 14px !important;\n  line-height: 21px !important;\n  color: #554854;\n}\n.noTextChevron-KEiXz {\n  margin-right: 0 !important;\n}\n.menuList-mr6F2 {\n  position: relative;\n  max-height: 200px;\n  padding: 5px 0;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.menuTitle-BlS9E {\n  padding: 0 10px;\n  font-weight: bold;\n}\n", "",{"version":3,"sources":["webpack://./app/EAssessment.UI.Common/app-components/form-controls/drop-down-menu/index.less"],"names":[],"mappings":"AAEA;EAEI,SAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,QAAA;AA8GJ;AApHA;EAUI,aAAA;EACA,mBAAA;EACA,cAAA;AA6GJ;AAzHA;EAgBI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA4GJ;AA/HA;EAuBI,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,qCAAA;EACA,kBAAA;EACA,2CAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EAEA,YAAA;EACA,gBAAA;AA0GJ;AAjJA;EA2CI,4BAAA;AAyGJ;AApJA;EA8CI,4BAAA;EACA,uBAAA;AAyGJ;AAxJA;EAmDI,aAAA;AAwGJ;AA3JA;EAuDI,kBAAA;AAuGJ;AA9JA;EA2DI,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,cAAA;AAsGJ;AArKA;EAmEI,0BAAA;AAqGJ;AAxKA;EAuEI,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAoGJ;AA/KA;EA8EI,eAAA;EACA,iBAAA;AAoGJ","sourcesContent":["@import '@cirrus/legacy/app-components/app/styles/colors/colors-default';\n\n:local {\n  .hiddenDescribeContainer {\n    height: 0;\n    margin: 0;\n    overflow: hidden;\n    padding: 0;\n    width: 0;\n  }\n\n  .button {\n    display: flex;\n    align-items: center;\n    color: @clr-gray-850;\n  }\n\n  .buttonTitle {\n    margin-right: 10px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .menu {\n    color: @clr-gray-850;\n    background-color: @clr-white;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 4px;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n    font-size: 14px;\n    margin: 2px 0 0;\n    padding: 5px 10px;\n    position: absolute;\n    text-align: left;\n    min-width: 160px;\n    width: 195px;\n    line-height: 2.2rem;\n\n    z-index: 100;\n    overflow: hidden;\n  }\n\n  .menu.hasSubMenu {\n    overflow: visible !important;\n  }\n  .menuList.hasSubMenu {\n    overflow: visible !important;\n    max-height: fit-content;\n  }\n\n  .menuTopAligned {\n    margin-top: 0;\n  }\n\n  .menu.hiddenMenu {\n    visibility: hidden;\n  }\n\n  .chevron {\n    font-size: 14px !important;\n    height: 19px !important;\n    width: 14px !important;\n    line-height: 21px !important;\n    color: @clr-gray-850;\n  }\n\n  .noTextChevron {\n    margin-right: 0 !important;\n  }\n\n  .menuList {\n    position: relative;\n    max-height: 200px;\n    padding: 5px 0;\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n  .menuTitle {\n    padding: 0 10px;\n    font-weight: bold;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"black": "#000",
	"yellow": "#008859",
	"yellowinprogress": "#BEA66E",
	"blackt30": "rgba(0, 0, 0, 0.3)",
	"black50": "rgba(0, 0, 0, 0.75)",
	"blue100": "#4690d1",
	"blue120": "#2791c6",
	"blue130": "#2196f3",
	"blue150": "#add2f7",
	"blue210": "#287ec7",
	"blue300": "#0478c6",
	"blue400": "#024b7b",
	"blue330": "#0055b0",
	"brown310": "#7f707d",
	"red": "red",
	"red70": "#f7bfb9",
	"red100": "#e87d7d",
	"red300": "#f35958",
	"red320": "#e05251",
	"red405": "#a94442",
	"red410": "#bc2b43",
	"red500": "#cc2d30",
	"red550": "#c60000",
	"red900": "#ff0000",
	"red905": "#cf4444",
	"red910": "#c60000",
	"green200": "#d8f0ea",
	"green210": "#c0e8dc",
	"green250": "#09998d",
	"green270": "#47bcb3",
	"green300": "#008859",
	"green310": "#4cb992",
	"green505": "#119264",
	"green520": "#00794f",
	"green650": "#b1dac6",
	"green700": "#008000",
	"green710": "#30b382",
	"green800": "#008859",
	"yellow90": "#fbdba0",
	"yellow410": "#fedb97",
	"orange200": "#eda04f",
	"orange300": "#ee9a02",
	"orange350": "#e7a257",
	"orange360": "#c3a565",
	"orange380": "#ff8c40",
	"orange400": "#ef7400",
	"orange420": "#ff6600",
	"orange550": "#bf5000",
	"blue170": "#7e9fc2",
	"blue220": "#537fad",
	"blue250": "#2879c7",
	"darkBlue400": "#272c40",
	"blue305": "#0055b0",
	"blue310": "#00829b",
	"brown320": "#7f707d",
	"gray75": "#f6f6f6",
	"gray80": "#eeeeee",
	"gray85": "#ecedec",
	"gray95": "#d9d9d9",
	"gray120": "#e5e9ec",
	"gray200": "#dddddd",
	"gray201": "#f2f2f2",
	"gray214": "#c4c4c4",
	"gray215": "#cccccc",
	"gray220": "#ccd0d3",
	"gray225": "#c1c9cd",
	"gray240": "#cfcfcf",
	"gray230": "#d9edf7",
	"gray245": "#8b8b8b",
	"gray250": "#808080",
	"gray320": "#dedce0",
	"gray400": "#5e5e5e",
	"gray420": "#555555",
	"gray850": "#554854",
	"gray305": "#757575",
	"gray500": "#333333",
	"gray800": "#4a4a4a",
	"gray820": "#40465d",
	"gray855": "#8b91a0",
	"gray280": "#999999",
	"gray50": "#f9f9f9",
	"gray100": "#ececec",
	"gray125": "#e4e4e4",
	"gray235": "#c1bebe",
	"gray350": "#6b546a",
	"gray600": "#f1f1f1",
	"gray720": "#b6b6b6",
	"gray740": "#b6a8b4",
	"gray755": "#ebebeb",
	"gray810": "#525252",
	"gray860": "#9b9b9b",
	"gray870": "#929292",
	"gray890": "#756372",
	"gray895": "#989898",
	"gray910": "#444059",
	"gray925": "#9c9c9c",
	"gray930": "#ddcfac",
	"gray935": "#5f6368",
	"gray920": "#757575",
	"gray950": "#ece4d0",
	"gray1000": "#ebe8e8",
	"gray1010": "#e6e6e6",
	"gray1050": "#e0e6f0",
	"gray1060": "#c6c6c6",
	"gray1100": "#ededed",
	"gray1120": "#8e818c",
	"gray1150": "#212121",
	"purple": "#6a546a",
	"transparent": "transparent",
	"hiddenDescribeContainer": "hiddenDescribeContainer-rOb38",
	"button": "button-4eNaw",
	"buttonTitle": "buttonTitle-OA1h9",
	"menu": "menu-Nf-LG",
	"hasSubMenu": "hasSubMenu-XMMdY",
	"menuList": "menuList-mr6F2",
	"menuTopAligned": "menuTopAligned-4Y0nI",
	"hiddenMenu": "hiddenMenu-DcSYT",
	"chevron": "chevron-YygZ6",
	"noTextChevron": "noTextChevron-KEiXz",
	"menuTitle": "menuTitle-BlS9E"
};
export default ___CSS_LOADER_EXPORT___;
